import { graphql, usePaginationFragment } from "react-relay";
import { GitBranch01Icon } from "@/icons";
import { FormattedMessage } from "react-intl";
import LoadMore from "@/components/LoadMore";
import { ListVersionHistoryFragment$key } from "./__generated__/ListVersionHistoryFragment.graphql";
import { Card } from "@/components/DatasetVersionHistory/Card";

const ListVersionHistoryFragment = graphql`
  fragment ListVersionHistoryFragment on Dataset
  @refetchable(queryName: "ListVersionHistoryFragmentPaginationQuery")
  @argumentDefinitions(
    cursor: { type: "String" }
    count: { type: "Int", defaultValue: 10 }
  ) {
    versions(after: $cursor, first: $count)
      @connection(key: "ListVersionHistoryFragment_versions") {
      edges {
        node {
          id
          ...CardVersionHistoryFragment
        }
      }
    }
  }
`;

interface Props {
  dataset: ListVersionHistoryFragment$key;
}

export function List({ dataset: fragment }: Props) {
  const {
    data: {
      versions: { edges: datasetVersions },
    },
    loadNext,
    hasNext,
    isLoadingNext,
  } = usePaginationFragment(ListVersionHistoryFragment, fragment);

  if (!datasetVersions.length) {
    return (
      <div className="w-full flex flex-col items-center justify-center gap-3 bg-grey-50 rounded-xl p-8">
        <GitBranch01Icon className="h-8 w-8 text-grey-700" />
        <div className="flex flex-col items-center justify-center gap-1">
          <p className="text-md font-semibold text-grey-950">
            <FormattedMessage defaultMessage="No versions yet" />
          </p>
          <p className="text-sm font-normal text-grey-700">
            <FormattedMessage defaultMessage="Create a version bellow" />
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      {datasetVersions.map(({ node }) => (
        <Card key={node.id} datasetVersion={node} />
      ))}
      <LoadMore
        loadMore={loadNext}
        hasMore={hasNext}
        isLoading={isLoadingNext}
      />
    </>
  );
}
